export default __webpack_public_path__ + "static/IBMPlexSans-Thin-Cyrillic-0acf69f319eaafd9f4257f47dc6201be.woff2";